export const featuredTeacher = {
  id: 1,
  name: "Rachel Morgan",
  role: "Product Designer",
  image: "/images/teachers/mpt.png",
  description:
    "This exceptional educator has consistently inspired and empowered students, making a significant impact on their learning journeys.",
};
